import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
import updateUserConfiguration from 'owa-session-store/lib/services/updateUserConfiguration';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default function selectNewCalendar(newSelectedCalendarId: string): Promise<void> {
    const selectedCalendarsViewState = getUserConfiguration().ViewStateConfiguration
        .SelectedCalendarsDesktop;
    if (
        selectedCalendarsViewState &&
        selectedCalendarsViewState.indexOf(newSelectedCalendarId) < 0
    ) {
        selectedCalendarsViewState.push(newSelectedCalendarId);
    }

    return updateUserConfiguration('OWA.ViewStateConfiguration', [
        userConfigurationDictionaryEntry({
            DictionaryKey: userConfigurationDictionaryObject({
                Type: 'String',
                Value: ['SelectedCalendarsDesktop'],
            }),
            DictionaryValue: userConfigurationDictionaryObject({
                Type: 'StringArray',
                Value: selectedCalendarsViewState,
            }),
        }),
    ]).then(response => {
        const responseItem = response.Body.ResponseMessages.Items[0];
        if (responseItem.ResponseClass == 'Success') {
            return Promise.resolve();
        } else {
            return Promise.reject('updateUserConfiguration failed: ' + responseItem.ResponseClass);
        }
    });
}
